module.exports = ".password-reset-card .card-header {\n    background-color: #0C9688;\n}\n\n.password-reset-card .card-body {\n    color: #373a3c;\n}\n\n.password-reset-card .btn-primary {\n    background-color: #0C9688;\n}\n\n.password-reset-card .form-spinner {\n    color: #0C9688;\n}\n\n.login-link  {\n    color: #0C9688 !important;\n    text-decoration: none;\n    font-weight: bold;\n}\n\n.login-link:visited {\n    color: #0C9688 !important;\n}\n\n.login-link:hover {\n    color: #0fbdab !important;\n}\n\n.login-link:active {\n    color: #0C9688 !important;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/password-reset/password-reset.component.css
// module id = 917
// module chunks = 4